<div
  class="toast-container fixed bottom-4 end-4 z-50 flex flex-col gap-2 sm:gap-3 max-w-[90vw] w-auto pointer-events-none"
>
  @for (toast of toasts; track toast.id) {
    <div
      [@toastAnimation]
      class="flex items-center justify-between gap-2 p-2 sm:px-4 sm:py-2 rounded-xl shadow-md min-h-10 sm:min-h-12 min-w-[15rem] sm:min-w-[23.4375rem] max-w-full sm:max-w-[31.25rem] pointer-events-auto direction-rtl font-yekan-bakh {{
        toast.variant === 'success'
          ? 'bg-success-surface'
          : toast.variant === 'warning'
            ? 'bg-warning-surface'
            : toast.variant === 'error'
              ? 'bg-error-surface'
              : 'bg-chart7'
      }}"
      role="alert"
      [attr.aria-live]="toast.variant === 'error' ? 'assertive' : 'polite'"
    >
      <div class="flex items-center gap-2 flex-1">
        <img
          [src]="getIcon(toast.variant)"
          alt="{{ toast.variant }} icon"
          class="flex-shrink-0 w-4 h-4 sm:w-6 sm:h-6"
        />
        <p
          class="text-sm font-regular sm:text-base sm:font-bold text-buttonText"
        >
          {{ toast.message }}
        </p>
      </div>
      <button
        class="flex p-1 items-center justify-center bg-transparent border-none cursor-pointer text-xs text-buttonText transition-colors duration-200 ease-in-out flex-shrink-0 hover:bg-black/10 hover:rounded-base focus:outline-2 focus:outline-white focus:outline-offset-2"
        (click)="removeToast(toast.id)"
        aria-label="Close"
        type="button"
      >
        <span class="material-icons !text-base font-bold">close</span>
      </button>
    </div>
  }
</div>
